<app-ngx-chronology [events]="entries"></app-ngx-chronology>